import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const ROUTE_LABELS = {
  'hizmetler': 'Tedaviler',
  'surec': 'Tedavi Süreci',
  'icerikler': 'İçerikler',
  'haberler': 'Haberler',
  'hakkimizda': 'Hakkımda',
  'iletisim': 'İletişim',
  'kvkk': 'KVKK & Çerez',
};

export function Breadcrumb({ items }) {
  const location = useLocation();

  // Auto-generate from route if items not provided
  const crumbs = items || (() => {
    const parts = location.pathname.split('/').filter(Boolean);
    return parts.map((part, i) => ({
      label: ROUTE_LABELS[part] || decodeURIComponent(part).replace(/-/g, ' '),
      href: '/' + parts.slice(0, i + 1).join('/'),
      current: i === parts.length - 1,
    }));
  })();

  if (!crumbs.length) return null;

  return (
    <nav aria-label="Breadcrumb" className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-10 py-3" data-testid="breadcrumb-nav">
      <ol className="flex items-center gap-1.5 text-xs text-[#5F6B76] flex-wrap">
        <li>
          <Link to="/" className="inline-flex items-center gap-1 hover:text-[#1F6E7A] transition-colors" data-testid="breadcrumb-home">
            <Home size={12} />
            <span>Ana Sayfa</span>
          </Link>
        </li>
        {crumbs.map((crumb, i) => (
          <li key={i} className="inline-flex items-center gap-1.5">
            <ChevronRight size={12} className="text-[#D1D5DB]" />
            {crumb.current ? (
              <span className="font-medium text-[#1F2937]" data-testid="breadcrumb-current">{crumb.label}</span>
            ) : (
              <Link to={crumb.href} className="hover:text-[#1F6E7A] transition-colors">{crumb.label}</Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
